"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const authenticated_client_1 = require("./authenticated.client");
class DashboardClientV2 extends authenticated_client_1.AuthenticatedClient {
    create(projectId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/users/me/dashboards`, payload);
            return response.payload;
        });
    }
    getAll(projectId, withPermissions) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/users/me/dashboards?withPermissions=${withPermissions}`);
            return response.payload;
        });
    }
    getById(projectId, id, withPermissions) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/users/me/dashboards/${id}?withPermissions=${withPermissions}`);
            return response.payload;
        });
    }
    update(projectId, id, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboards/${id}`, payload);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpDelete(`/v2/projects/${projectId}/users/me/dashboards/${id}`);
            return response.payload;
        });
    }
    share(projectId, dashboardId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/share`, payload);
            return response.payload;
        });
    }
    updatePermissions(projectId, id, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v2/projects/${projectId}/users/me/dashboards/${id}/update-permissions`, payload);
            return response.payload;
        });
    }
    getSharedMembers(projectId, dashboardId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v2/projects/${projectId}/users/me/dashboards/${dashboardId}/shared-members`);
            return response.payload;
        });
    }
    export(projectId, id, type, paperSize, context, selectedContexts) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                paperSize,
                context,
                selectedContexts: selectedContexts && selectedContexts.length !== 0 ? selectedContexts : undefined,
            };
            const response = yield this.executeRaw('post', `/v2/projects/${projectId}/users/me/dashboards/${id}/export/${type}`, body);
            return {
                buffer: response.data,
                filename: DashboardClientV2.getFileNameFromContentDisposition(response.headers['content-disposition']),
                contentType: response.headers['content-type'],
            };
        });
    }
    static getFileNameFromContentDisposition(contentDisposition) {
        if (!contentDisposition)
            return '';
        const match = contentDisposition.match(/filename[^;=\n]*=(?:(['"])(.*?)\1|[^;\n]*)/);
        if (match && match.length === 3) {
            const [_match, _quote, filename] = match;
            return filename;
        }
        return '';
    }
}
exports.DashboardClientV2 = DashboardClientV2;
//# sourceMappingURL=dashboard.client.v2.js.map